import React from "react"
import { ListOfFacilities } from "./ListOfFacilities"

const Facilities = () => {

    return (
        <>
            <ListOfFacilities />
        </>
    )
}

export { Facilities }